import { useLocalStorage } from "@vueuse/core";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logError } from "~vue/utils/logError";
import { logUserInteraction } from "~vue/utils/logUtils";

export interface ShareBackTarget {
    id: string;
    name: string;
}

export const withShareBackTarget = (url: string, targetId?: string): string => {
    if (!targetId) {
        return url;
    }
    const destination = new URL(url, globalThis.location.origin);
    destination.searchParams.set("share_back", targetId);
    return `${destination.pathname}${destination.search}${destination.hash}`;
};

export const useProfileShareBack = (viewerId: string) => {
    const onError = (error: unknown) => {
        logError(error, { tags: { feature: "profile_share_back" } });
        void logUserInteraction(AmplitudeEventNames.PROFILE_SHARE_BACK_STORAGE_FAILED);
    };
    const answered = useLocalStorage<string[]>(`profile-share-back-answered:${viewerId}`, [], { onError });

    const hasAnsweredPrompt = (targetId: string): boolean => answered.value.includes(targetId);
    const markPromptAnswered = (targetId: string) => {
        if (!hasAnsweredPrompt(targetId)) {
            answered.value = [...answered.value, targetId];
        }
    };

    return { hasAnsweredPrompt, markPromptAnswered };
};
